export type Layout = null | "confluence" | "jira";

export const TIMEOUT = 600000;

export function getLayout(products: string[]): Layout {
    if (products.some((product) => product.includes("confluence"))) {
        return "confluence";
    }
    return null;
}
